import React from 'react';
import { useTheme } from '@mui/material';
import { stripAlpha } from '@jbrowse/core/util';
export default function SVGBackground({ width, height, shift, }) {
    const theme = useTheme();
    return (React.createElement("rect", { width: width + shift * 2, height: height, fill: stripAlpha(theme.palette.background.default) }));
}
